import http from "../utils/http-client"


//统计首页cell数据
export const get_cells=()=>{
    return http.get<StatisticCellModel>({
        disableLoading:true,
        url:"/api/statistic/active/cells"
    })
}


//统计首页图表数据
export const get_chart_data=(type:number=1,start_time?:Nullable<Date>,end_time?:Nullable<Date>)=>{
    return http.get<Array<StatisticChartModel>>({
        url:"/api/statistic/active/chart",
        disableLoading:true,
        params:{
            type:type,
            start_time:start_time,
            end_time:end_time
         }
    })
}

//统计首页用户分布地图数据
export const get_map_data=(start_time?:Nullable<Date>,end_time?:Nullable<Date>)=>{
    return http.get<Array<StatisticMapModel>>({
        url:"/api/statistic/active/maps",
        disableLoading:true,
        params:{
            start_time:start_time,
            end_time:end_time
         }
    })
}


//统计首页图表数据
export const get_viewers_data=(start_time?:Nullable<Date>,end_time?:Nullable<Date>)=>{
    return http.get<StatisticViewerModel>({
        url:"/api/statistic/active/viewers",
        disableLoading:true,
        params:{
            start_time:start_time,
            end_time:end_time
         }
    })
}


//下载阅读数据excel文件
export const download_viewers_data_excel=(start_time?:Nullable<Date>,end_time?:Nullable<Date>)=>{
    return http.download<Blob>({
        url:"/api/statistic/active/viewers/export",
        disableLoading:true,
        params:{
            start_time:start_time,
            end_time:end_time
         }
    })
}

//下载活跃图表数据excel文件
export const download_chart_data_excel=(start_time?:Nullable<Date>,end_time?:Nullable<Date>)=>{
    return http.download<Blob>({
        url:"/api/statistic/active/chart/export",
        disableLoading:true,
        params:{
            start_time:start_time,
            end_time:end_time
         }
    })
}

//活跃标记
export const append_activate_user=()=>{
    return http.post({
        url:"/api/statistic/active/insert",
        disableLoading:true,
    })
}